import React from 'react';
import { Form } from 'react-form';
import { connect } from 'react-redux';
import _ from 'lodash';
import Translate from 'translate';

import { FormGroup, Text, Checkbox, RadioButton } from 'components/FormElements/';
import { loginUser, toggleLoading, toggleAlertError } from 'stores/actions/';
import UserService from 'services/UserService';
import Modal from "react-responsive-modal";

class Settings extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: {}
    };
    this.submitForm = this.submitForm.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    if( !this.props.open && nextProps.open ) {
      this.getData()
    }
  }

  getData() {
    const { userId, toggleLoading } = this.props;

    toggleLoading( true );

    UserService.getUserSettings( userId ).then( ( response ) => {
      if( !response.errors ) {
        let data = response.data;
        data.openIn = data.afterDashboard ? 1 : 2;
        this.setState( { data } );
      }
      toggleLoading( false );
    } );
  }

  submitForm( formData ) {
    const { userId, toggleAlertError, toggleLoading } = this.props;
    this.formData = _.cloneDeep( formData );

    toggleLoading( true );

    const data = {
      ...formData,
      afterDashboard: formData.openIn === 1,
      afterPanel: formData.openIn === 2,
    };

    UserService.updateUserSettings( userId, data ).then( ( response ) => {
      toggleLoading( false );
      if( !response.errors ) {
        const { filterFacebook, filterTwitter, filterEmail, filterMy, beforeDelete, filterPhone, agentSocialTab, filterWalkIn } = formData;
        this.props.loginUser( { filterFacebook, filterTwitter, filterEmail, filterMy, beforeDelete, filterPhone, agentSocialTab,filterWalkIn } );
        toggleAlertError( <Translate id="dataSaved"/> );
        return this.closeModal()
      } else {
        return toggleAlertError( response.errors );
      }
    } )
  }

  closeModal = () => {
    this.setState( { data: {} } );
    this.props.onClose()
  };

  render() {
    return (
      <Modal closeOnEsc={false}
             little
             modalClassName="col-md-5"
             open={this.props.open}
             onClose={this.closeModal}>
        <h5 className="mt-0"><Translate id="settings"/></h5>

        <div className="row">
          <div className="col-md-12">
            <Form
              onSubmit={this.submitForm}
              defaultValues={this.formData || this.state.data}
            >
              {( { submitForm } ) =>
                <form onSubmit={submitForm}>
                  <FormGroup>
                    <Checkbox field="beforeDelete" label={<Translate id="settings.showConfirmation"/>}
                              labelStyle={{ width: 'auto' }}/>
                  </FormGroup>
                  <FormGroup>
                    <Checkbox field="languageEnabled" label={<Translate id="settings.enableLanguage"/>}
                              labelStyle={{ width: 'auto' }}/>
                  </FormGroup>

                  <FormGroup>
                    <label><Translate id="setting.loadInfoFilter"/>:</label>
                    <Checkbox field="filterFacebook" label={<Translate id="facebook"/>}
                              labelPosition="right"
                              labelStyle={{ width: 'auto' }}/>
                    <Checkbox field="filterTwitter" label={<Translate id="twitter"/>}
                              labelPosition="right"
                              labelStyle={{ width: 'auto' }}/>
                    <Checkbox field="filterEmail" label={<Translate id="email"/>}
                              labelPosition="right"
                              labelStyle={{ width: 'auto' }}/>
                    <Checkbox field="filterPhone" label={<Translate id="phone"/>}
                              labelPosition="right"
                              labelStyle={{ width: 'auto' }}/>
                    <Checkbox field="filterMy" label={<Translate id="settings.myWork"/>}
                              labelPosition="right"
                              labelStyle={{ width: 'auto' }}/>
                    <Checkbox field="filterWalkIn" label={<Translate id="walkin"/>}
                              labelPosition="right"
                              labelStyle={{ width: 'auto' }}/>
                  </FormGroup>

                  <FormGroup>
                    <label><Translate id="setting.afterLoginRedirect"/>:</label>
                    <RadioButton field="openIn"
                                 labelPosition="right"
                                 options={[{ id: 1, label: <Translate id="dashboard"/> }, {
                                   id: 2,
                                   label: <Translate id="agentPanel"/>
                                 }]}
                                 labelStyle={{ width: 'auto' }}/>
                  </FormGroup>

                  <FormGroup>
                    <label><Translate id="setting.agentSocialTab"/>:</label>
                    <RadioButton field="agentSocialTab"
                                 labelPosition="right"
                                 options={[{ id: 'socialNetworks', label: <Translate id="socialNetworks"/> }, {
                                   id: 'chat',
                                   label: <Translate id="chat"/>
                                 }]}
                                 labelStyle={{ width: 'auto' }}/>
                  </FormGroup>

                  <div className="text-right mt-4">
                    <button type="submit" className="btn btn-info px-4"><Translate id="save"/></button>
                  </div>
                </form>
              }
            </Form>
          </div>
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = ( state, ownProps ) => ( {
  userId: state.user.id,
} );

const mapDispatchToProps = dispatch => ( {
  loginUser: ( user ) => {
    dispatch( loginUser( user ) );
  },
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( Settings );



// WEBPACK FOOTER //
// ./routes/app/components/Navigation/SettingsModal/index.js